import { useUnmount } from 'react-use';

import { PreInterview, PreInterviewQuery } from '@dreryk/egabinet-pre-interview-frontend-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { paginations } from '@dreryk/command-query-ws-client';
import { Slot } from '@dreryk/watermelon';

import { PreInterviewState, usePreInterviewGlobalState } from './PreInterviewResolver.hooks';

const DEFAULT_PAGINATION = paginations.all();

type PreInterviewResolverProps = {
   readonly appointmentIds: number[];
};

export const PreInterviewResolver = (props: PreInterviewResolverProps): null => {
   const { updatePreInterviewState, resetPreInterviewState } = usePreInterviewGlobalState();

   useCqrsSearch<PreInterview>(
      () => {
         const query = new PreInterviewQuery();
         query.appointmentIds = Slot.of(props.appointmentIds);
         return query;
      },
      DEFAULT_PAGINATION,
      {
         onSuccess: (preInterviews) => {
            updatePreInterviewState(
               props.appointmentIds
                  .map<[number, PreInterviewState | null]>((appointmentId) => [appointmentId, null])
                  .concat(
                     preInterviews.map((preInterview) => [
                        preInterview.appointmentId,
                        { status: preInterview.status, surveyId: preInterview.surveyId },
                     ])
                  )
            );
         },
      }
   );

   useUnmount(resetPreInterviewState);

   return null;
};
